import { getApp, getApps, initializeApp } from 'firebase/app'
import { getMessaging, getToken, isSupported } from 'firebase/messaging'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
    apiKey: 'AIzaSyCfy2oP118tSpOy9YUsfbip6YTkaMENoKg',
    authDomain: 'datacentral-notification.firebaseapp.com',
    projectId: 'datacentral-notification',
    storageBucket: 'datacentral-notification.firebasestorage.app',
    messagingSenderId: '537032662769',
    appId: '1:537032662769:web:778186314533daab3dd350',
    measurementId: 'G-ZEK3DST9VM',
}

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp()

const db = getFirestore(app)

const messaging = async () => {
    const supported = await isSupported()
    return supported ? getMessaging(app) : null
}

export const fetchToken = async () => {
    try {
        const fcmMessaging = await messaging()

        if (fcmMessaging) {
            const token = await getToken(fcmMessaging, {
                vapidKey:
                    'BD2zp9BMJ8eT9wFPcEmLt6NfW5Wu1-iXOhrWdhmzZAzVhHr3_Bwsdhlet_zWa4I8CCl9yajlFBXZieXwDasTtsU',
            })
            return token
        }
        return null
    } catch (err) {
        console.error('An error occurred while fetching the token:', err)
        return null
    }
}

export { messaging, db }
